import { useTranslation } from 'react-i18next';
import { CompanyDetailAndJobGroups } from '@types';
import { Header, Page, Toolbox } from 'redesign';
import { Box } from '@mui/material';
import { SettingsDetailTabs } from './settings-detail-tabs/settings-detail-tabs';
import { CompanyDataProvider } from '../../management/company/company-data-provider';

export const SettingsPageDataProvider = () => {
  return (
    <CompanyDataProvider>
      {(companyData) => <SettingsPage companyData={companyData} />}
    </CompanyDataProvider>
  );
};

const SettingsPage = (props: { companyData: CompanyDetailAndJobGroups }) => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Page toolbox={<Toolbox />} header={<Header titleText={t('settings-detail-page.title')} />}>
      <Box width="100%">
        <SettingsDetailTabs companyData={props.companyData} />
      </Box>
    </Page>
  );
};
